// Число стран для <head> страниц подбора: старт, результат, приглашение.
// Без входа — превью читают мессенджеры. origin — чтобы превью-версия
// показывала свою картинку, а не боевую.

import { createServerFn } from "@tanstack/react-start";
import { activeCountryCount } from "@/lib/edu-countries-count.server";
import { previewOrigin } from "@/lib/edu-guest-invite.server";

export type CountriesHead = { count: number | null; origin: string };

export const getEduCountriesCount = createServerFn({ method: "GET" }).handler(
  async (): Promise<CountriesHead> => ({ count: await activeCountryCount(), origin: previewOrigin() }),
);
